import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { datePickerMinDate, mobilePattern } from '../../shared/constants';
import { catchError, debounceTime, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { NavbarComponent } from '../../navbar/navbar.component';
import * as FileSaver from 'file-saver';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TaskFormComponent } from '../../task-management/task-form/task-form.component';
import moment from 'moment';
import { isBefore, isSameDay } from 'date-fns';

@Component({
	selector: 'app-tasks',
	templateUrl: './tasks.component.html',
	styleUrl: './tasks.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class TasksComponent implements OnInit, OnDestroy, AfterViewInit {
	constructor(private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent, private cdr: ChangeDetectorRef) { }
	@ViewChild(TaskFormComponent) taskForm!: TaskFormComponent;
	todoStatusName = "TO DO";
	todoListId = "todoList";
	inProgressStatusName = "IN PROGRESS";
	inProgressListId = "inProgressList";
	doneStatusName = "DONE";
	doneListId = "doneList";
	taskList: any[] = [
		{
			status_name: this.todoStatusName,
			status_id: environment.production ? 1 : 1,
			id: this.todoListId,
			connectedTo: [this.inProgressListId, this.doneListId],
			page_length: 10,
			page: 1,
			isListFinished: false,
			isListLoading: false,
			list: []
		},
		{
			status_name: this.inProgressStatusName,
			status_id: environment.production ? 2 : 2,
			id: this.inProgressListId,
			connectedTo: [this.todoListId, this.doneListId],
			page_length: 10,
			page: 1,
			isListFinished: false,
			isListLoading: false,
			list: []
		},
		{
			status_name: this.doneStatusName,
			status_id: environment.production ? 3 : 3,
			id: this.doneListId,
			connectedTo: [this.todoListId, this.inProgressListId],
			page_length: 10,
			page: 1,
			isListFinished: false,
			isListLoading: false,
			list: []
		}
	];
	statusList: any[] = [];
	userList: any[] = [];
	newsList: any[] = [];
	eventList: any[] = [];
	loadingNews = false;
	loadingEvents = false;
	classes = [
		{ status_name: this.todoStatusName, color: "#FFFFFF", "background-color": "#FF5C5B" },
		{ status_name: this.inProgressStatusName, color: "#212529", "background-color": "#FFD050" },
		{ status_name: this.doneStatusName, color: "#FFFFFF", "background-color": "#52BB76" }
	];
	dragEnteredId: any = null;
	getColor(task: any) {
		let obj: any = this.classes.find(c => c.status_name == task.status_name);
		if (obj) {
			const { status_name, ...newObj } = obj;
			return newObj;
		} else {
			return {};
		}
	}
	getColor1(task: any) {
		let obj: any = this.classes.find(c => c.status_name == task.name);
		if (obj) {
			const { name, ...newObj } = obj;
			return newObj;
		} else {
			return {};
		}
	}
	isDueDatePassed(task: any) {
		if (task.status_name == this.doneStatusName) {
			return false;
		}
		if (task.due_date) {
			const due_date = moment(task.due_date, 'DD-MM-YYYY').toDate();
			const today = new Date();
			if (isBefore(due_date, today) && !isSameDay(due_date, today)) {
				return true;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	minDate = datePickerMinDate;
	filters: any = {
		lead: null,
		assigned: null,
		department: null,
		due_date_start: null,
		due_date_end: null
	}
	formCtrlSub!: Subscription;
	searchControl: FormControl = new FormControl(null);
	showScroll = false;
	disableDepartment = false;

	ngOnInit(): void {
		this.apiService.departmentList$.subscribe((departments: any[]) => {
			if (departments && departments.length) {
				if (departments.length === 1) {
					//If departments has only 1 entry then other are removed as user is Lead(with department) or Assignee
					this.disableDepartment = true;
					this.filters.department = departments[0].id;
				}
				this.apiService.userData$.subscribe((user: any) => {
					if (user) {
						this.filters.assigned = user.id;
						this.getAllTasks();
						this.apiService.userList$.subscribe((userList) => {
							if (userList) {
								this.userList = userList.filter((u) => true);
							}
						});
					}
				});
			}
		});
		this.getTaskStatusList();
		this.getNews();
		this.getEvents();

	}

	ngAfterViewInit(): void {
		this.formCtrlSub = this.searchControl.valueChanges.pipe(debounceTime(500)).subscribe(newValue => {
			this.getAllTasks();
		});
	}

	ngOnDestroy() {
		try {
			this.formCtrlSub.unsubscribe();
		} catch (error) { }
	}

	getNews() {
		this.loadingNews = true;
		this.apiService.getNews({}).subscribe({
			next: (data: any) => {
				this.newsList = data;
				this.loadingNews = false;
			}, error: (error) => {
				this.newsList = [];
				this.loadingNews = false;
			}
		});
	}

	getEvents() {
		this.loadingEvents = true;
		this.apiService.getEvent({}).subscribe({
			next: (data: any) => {
				this.eventList = data;
				this.loadingEvents = false;
			}, error: (error) => {
				this.eventList = [];
				this.loadingEvents = false;
			}
		});
	}

	eventToView: any = null;
	viewEvent(event: any) {
		this.eventToView = event;
		$("#viewEventModal").modal("show");
	}

	getDepartmentName(id: any) {
		return this.navbar.departmentList.find((d) => d.id == id)?.name;
	}

	getTaskStatusList() {
		this.apiService.getAllTaskStatusList().subscribe({
			next: (data: any) => {
				this.statusList = data;
			}, error: (error) => {
				this.statusList = [];
			}
		});
	}

	getStatusId(status_name: string) {
		return this.statusList.find((s) => s.name == status_name).id || null;
	}

	getPaginationOptions(index: number) {
		let options: any = {
			draw: 1,
			length: this.taskList[index].page_length,
			start: (this.taskList[index].page - 1) * this.taskList[index].page_length,
			status: this.taskList[index].status_id
		}
		return options;
	}

	getFilter() {
		const filters: any = {};
		if (this.filters.department) {
			filters["department"] = this.filters.department;
		}
		if (this.filters.lead) {
			filters["lead"] = this.filters.lead;
		}
		if (this.filters.assigned) {
			filters["assigned"] = this.filters.assigned;
		}
		if (this.filters.due_date_start) {
			filters["due_date_start"] = this.apiService.getDateStringFromDate(this.filters.due_date_start, 'YYYY-MM-DD');
		}
		if (this.filters.due_date_end) {
			filters["due_date_end"] = this.apiService.getDateStringFromDate(this.filters.due_date_end, 'YYYY-MM-DD');
		}
		filters["searchVal"] = this.searchControl.value || "";
		return filters;
	}

	getAllTasks() {
		this.taskList[0].list = [];
		this.taskList[0].page = 1;
		this.taskList[0].isListFinished = false;
		this.taskList[1].list = [];
		this.taskList[1].page = 1;
		this.taskList[1].isListFinished = false;
		this.taskList[2].list = [];
		this.taskList[2].page = 1;
		this.taskList[2].isListFinished = false;
		this.getTasks(0);
		this.getTasks(1);
		this.getTasks(2);
	}

	getTasks(index: number) {
		if (!this.taskList[index].isListFinished && !this.taskList[index].isListLoading) {
			let payload: any = {
				...this.getPaginationOptions(index),
				...this.getFilter()
			};
			this.taskList[index].isListLoading = true;
			this.apiService.getTask(payload).subscribe({
				next: (data: any) => {
					this.showScroll = true;
					this.taskList[index].isListLoading = false;
					if (data.data.length == this.taskList[index].page_length) {
						this.taskList[index].page++;
					} else {
						this.taskList[index].isListFinished = true;
					}
					if (index == 0) {
						this.taskList[index].list = [...this.taskList[index].list, ...data.data.filter((tsk) => tsk.status_name == this.todoStatusName)];
					} else if (index == 1) {
						this.taskList[index].list = [...this.taskList[index].list, ...data.data.filter((tsk) => tsk.status_name == this.inProgressStatusName)];
					} else if (index == 2) {
						this.taskList[index].list = [...this.taskList[index].list, ...data.data.filter((tsk) => tsk.status_name == this.doneStatusName)];
					}
				}, error: (error) => {
					this.taskList[index].isListLoading = false;
					this.taskList[index].isListFinished = true;
					/* if (index == 0) {
						this.taskList[index].list = [];
					} else if (index == 1) {
						this.taskList[index].list = [];
					} else if (index == 2) {
						this.taskList[index].list = [];
					} */
				}
			});
		}
	}

	onDragEntered(dragEnteredId: string) {
		this.dragEnteredId = dragEnteredId;
	}

	onDragExited() {
		this.dragEnteredId = null;
	}

	moveLoader: any = null;
	drop(event: CdkDragDrop<any[]>) {
		this.dragEnteredId = null;
		if (event.previousContainer === event.container) {
			/* moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
			this.cdr.detectChanges(); */
		} else {
			let task: any = {
				id: event.previousContainer.data[event.previousIndex].enc_id
			}
			if (event.container.id == this.todoListId) {
				task.status_id = this.getStatusId(this.todoStatusName);
				task.start_date = null;
				task.fin_date = null;
			} else if (event.container.id == this.inProgressListId) {
				task.status_id = this.getStatusId(this.inProgressStatusName);
				task.start_date = this.apiService.getDateStringFromDate(new Date(), 'YYYY-MM-DD');
				task.fin_date = null;
			} else if (event.container.id == this.doneListId) {
				task.status_id = this.getStatusId(this.doneStatusName);
				task.fin_date = this.apiService.getDateStringFromDate(new Date(), 'YYYY-MM-DD');
			}
			this.moveLoader = event.previousContainer.data[event.previousIndex].id;
			this.apiService.createUpdateTask(task).subscribe({
				next: (data: any) => {
					if (event.container.id == this.todoListId) {
						event.previousContainer.data[event.previousIndex].status_name = this.todoStatusName;
						event.previousContainer.data[event.previousIndex].status = this.getStatusId(this.todoStatusName);
					} else if (event.container.id == this.inProgressListId) {
						event.previousContainer.data[event.previousIndex].status_name = this.inProgressStatusName;
						event.previousContainer.data[event.previousIndex].status = this.getStatusId(this.inProgressStatusName);
					} else if (event.container.id == this.doneListId) {
						event.previousContainer.data[event.previousIndex].status_name = this.doneStatusName;
						event.previousContainer.data[event.previousIndex].status = this.getStatusId(this.doneStatusName);
					}
					transferArrayItem(
						event.previousContainer.data,
						event.container.data,
						event.previousIndex,
						event.currentIndex
					);
					this.cdr.detectChanges();
					this.toastr.success("Updated successfully", 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					this.getAllTasks();
					this.moveLoader = null;
				}, error: (error) => {
					this.moveLoader = null;
					this.toastr.error("Something went wrong", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
			/* Swal.fire({
				title: 'Please confirm',
				html: 'Are you sure you want to change task status?',
				icon: 'question',
				showCancelButton: true,
				confirmButtonText: 'Change',
				cancelButtonText: 'Cancel'
			}).then((result) => {
				if (result.value) {
					
				}
			}) */
		}
	}

	taskClick(task: any) {
		this.createEditTask(task.enc_id);
	}

	createEditTask(uId: any) {
		this.taskForm.initForm(uId);
	}

	deleteLoader: any = null;
	deleteTask(e: any, task: any) {
		try {
			e.stopPropagation()
		} catch (error) {

		}
		Swal.fire({
			title: 'Please confirm',
			html: 'Are you sure you want to delete task?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Delete',
			confirmButtonColor: '#DC3545',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.deleteLoader = task.id;
				this.apiService.deleteTask(task.enc_id).subscribe({
					next: (data: any) => {
						this.deleteLoader = null;
						this.toastr.success("Task deleted successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.getAllTasks();
					}, error: (error) => {
						this.deleteLoader = null;
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	dragDisabled(task: any) {
		try {
			return !this.navbar.user?.tms_access?.change_task_status && this.navbar.user.id != task.assigned && this.navbar.user.id != task.lead;
		} catch (error) {
			return true;
		}
	}

	clearSearchInput() {
		this.searchControl.setValue(null);
	}

	excelLoader = false;
	getTasksExcel(e: any) {
		e.stopPropagation();
		let payload: any = {
			...this.getFilter()
		};
		this.excelLoader = true;
		this.apiService.getTasksExcel(payload).subscribe({
			next: res => {
				let excelData: any = res.body;
				this.excelLoader = false;
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let fileName = "Tasks.xlsx";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.excelLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	showDownloadExcelBtn() {
		let showBtn = false;
		if (this.navbar.user?.tms_access?.task_excel) {
			this.taskList.map((d) => {
				if (d.list.length) {
					showBtn = true;
				}
			})
		}
		return showBtn;
	}
}
